import { HttpErrorResponse } from "@angular/common/http";
import { ErrorHandler, inject } from "@angular/core";
import { ErrorStore } from "@stores";
import {MatSnackBar} from '@angular/material/snack-bar';
import { MatDialog } from "@angular/material/dialog";
import { ErrorDialogComponent } from "../components/error-dialog/error-dialog.component";

export class GlobalErrorHandler implements ErrorHandler {
    private snackBar = inject(MatSnackBar);
    private dialog = inject(MatDialog);
    private errorStore = inject(ErrorStore);

    handleError(error: unknown): void {
        if (error instanceof HttpErrorResponse) {
            this.errorStore.addError( `name: ${error.name} | code: ${error.status} | status: ${error.statusText} | message: ${error.message}`);
            
            const snackbarRef = this.snackBar.open('Something went wrong', 'View Details');

            snackbarRef.onAction().subscribe({
                next: () => this.dialog.open(ErrorDialogComponent, {
                    width: '1200px'
                })
            });
        }
            

        console.error(error);
    }
}